module.exports = __webpack_public_path__ + "static/logo-agcom-961f8dfbbe6e8194616acd28bd8c9d5b.webp";